import { cameraApiRequest } from './cameraApiRequest';

/**
 * Deletes a still (its bank item, softly): 204. Needs `cameras_manage`.
 */
export const deleteCameraStill = ({
  projectId,
  cameraId,
  stillId,
  activeEmployerInfo,
}) =>
  cameraApiRequest({
    method: 'DELETE',
    apiPath: `projects/${projectId}/cameras/${cameraId}/stills/${stillId}`,
    activeEmployerInfo,
  });
